import * as React from "react"

import { Box } from '@mui/material'
import { CommonFilters } from '@components'
import { COMMON_FILTER_KEYS, USER_ROLES } from '@constants'
import { useUserApp, useAppDefaultFilters } from '@hooks'
import {isLoadingCommonFilters, isSystemBusy} from '@signals'
import { useEffect } from 'react'
import { CUSTOM_DASHBOARD_ROUTES } from '@constants/routes'
import {isEmptyEmbargoDate} from "./@signals";


export default function EmbargoDateFilters() {
	const { userRole } = useUserApp()
	const isMarketPlaceUser = userRole === USER_ROLES.MARKETPLACES
	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(CUSTOM_DASHBOARD_ROUTES.EMBARGO_ID, CUSTOM_DASHBOARD_ROUTES.ID)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	return <Box data-tour="embargo-filters">
	<CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			sku: true, favFilters: true,
			favFiltersOnlyLine: true, skuGroup: true,
			seller: isMarketPlaceUser
		}}
		compProps={{
			country: { disableClearable: true, grid: { md: 4 } },
			site: { grid: { md: 4 } },
			sku: { grid: { md: 4 } },
			skuGroup: { grid: { md: 4 } },
			category: { grid: { md: 4 } },
			favFiltersOnlyLine: { grid: { md: 10 } },
			brand: { grid: { md: 4 } },
			favFilters: {
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU
				],
				dashboardKey: CUSTOM_DASHBOARD_ROUTES.EMBARGO_ID
			}
		}}
		onSubmit={() => {
			isSystemBusy.value = false
			isLoadingCommonFilters.value = true
			isEmptyEmbargoDate.value = false
		}}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}
